import { HeadingOne, HeadingTwo } from '@/general/component/typography/landing'
type Props = {
    caption: string;
    label: string;
}

const Title = ({ caption, label }: Props) => {
  return (
        <div className="
            flex flex-col gap-14
            text-center items-center
        ">
            <img className='w-28' src="/media/elements/separator-title.png" alt="separator" />
            <HeadingOne>{label}</HeadingOne>
            <HeadingTwo> {caption} </HeadingTwo>
        </div>
  )
}

export default Title
